import { ServiceBase } from '../../../core/services/ServiceBase'
import CartAndOrderProxy from './proxy'

class CartAndOrderService extends ServiceBase {
  getCartItems = () => this.getData(() => CartAndOrderProxy.getCartItems())

  delCartItem = (params) =>
    this.getData(() => CartAndOrderProxy.delCartItem(params))

  postOrder = (params) =>
    this.getData(() => CartAndOrderProxy.postOrder(params))

  postOrderZero = (params) =>
    this.getData(() => CartAndOrderProxy.postOrderZero(params))

  getDiscount = (params) =>
    this.getData(() => CartAndOrderProxy.getDiscount(params))

  getVoucher = (params) =>
    this.getData(() => CartAndOrderProxy.getVoucher(params))

  getUserPricingPackages = (params) =>
    this.getData(() => CartAndOrderProxy.getUserPricingPackages(params))

  getUserProfile = (params) =>
    this.getData(() => CartAndOrderProxy.getUserProfile(params))

  getBankTransferInfo = (params) =>
    this.getData(() => CartAndOrderProxy.getBankTransferInfo(params))

  getSimilarCompanies = (params) =>
    this.getData(() => CartAndOrderProxy.getSimilarCompanies(params))

  getMostPopularCompanies = (params) =>
    this.getData(() => CartAndOrderProxy.getMostPopularCompanies(params))

  getTerms = (params) => this.getData(() => CartAndOrderProxy.getTerms(params))
}

export default new CartAndOrderService()
